import { ComponentType as u } from "../../registries/types/propTypes.js";
const l = (s) => {
  const n = Array.isArray(s == null ? void 0 : s.faq_groups) ? s == null ? void 0 : s.faq_groups[0] : s == null ? void 0 : s.faq_groups, e = n == null ? void 0 : n.faq_groups.map((i) => {
    const p = i.group_title, { faqs: o } = i, t = o == null ? void 0 : o.map((r) => ({
      question: r.question,
      answer: r.answer
    }));
    return {
      title: p,
      faqQuestionAnswer: t
    };
  });
  return {
    displayTitle: n.display_title,
    faqsGroups: e,
    componentType: u.faq_groups,
    sanitize: n.sanitize ?? !1,
    sanitizationConfig: n.sanitizationConfig ?? {}
  };
};
export {
  l as default
};
//# sourceMappingURL=faqGroupsTransformer.js.map
